import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import FeatureCard from "../components/FeatureCard";
import TinySlider from "tiny-slider-react";
import VideoBackground from "../components/VideoBackground";
import CardBeneficios from "../components/CardBeneficios";
import ba from "../assets/images/sidom/svg/Ar.svg";
import useStore from "../store/useStore";
import BeneficiosDegradeBox from "../components/BeneficiosDegradeBox";
import BarrerasTecnologicas from "../components/BarrerasTecnologicas";
import TestimoniosComex from "../components/TestimoniosComex";
import MisimClientes from "../components/MisimClientes";

import MisimDemoForm from "../components/MisimForm";

const settings = {
  container: ".tiny-one-item",
  items: 4,
  controls: true,
  mouseDrag: true,
  loop: true,
  rewind: true,
  animateOut: "rollOut",
  autoplay: false,
  autoplayButtonOutput: false,
  autoplayTimeout: 3000,
  navPosition: "bottom",
  controlsText: [
    '<i class="mdi mdi-chevron-left "></i>',
    '<i class="mdi mdi-chevron-right"></i>',
  ],
  nav: true,
  speed: 1000,
  gutter: 20,
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 2,
    },
    1024: {
      items: 4,
    },
  },
};
const productos = [
  {
    title: "Sin tiempos de conexión y desconexión",
    description:
      "en distintos sistemas centralizando en una única plataforma todas las herramientas de uso diario.",
  },
  {
    title: "Mayor productividad validando y oficializando",
    description:
      "varias destinaciones aduaneras al mismo tiempo, en distintas aduanas y de forma autónoma.",
  },
  {
    title: "Presentaciones automatizadas",
    description: "de documentos o validaciones AFIP desde la plataforma.",
  },
  {
    title: "Acceso en tiempo real a las declaraciones aduaneras",
    description: "a través de nuestra plataforma,  sin límites de usuarios.",
  },
  {
    title: "Visibilidad 360° de todas las operaciones",
    description:
      "Control de operaciones y movimientos desde cualquier dispositivo y lugar.",
  },
  {
    title: "Reportes automáticos personalizables",
    description: "sobre vencimientos, saldos y estados de las operaciones",
  },
];
const features = [
  {
    title: "MRE",
    description:
      "Motor de seguimiento y descargas de importaciones temporales, RAF, reposición de stock con actualización automática de saldos desde ARCA.",
  },
  {
    title: "Nomenclador",
    description: "Incorporado y actualizado con la última normativa.",
  },
  {
    title: "ADM",
    description:
      "Configuración de reglas administrativas con lA, automatiza el 80% del proceso de facturación con el sistema administrativo/contable más moderno del mercado.",
  },
  {
    title: "Conect",
    description:
      "Conectividad al SIM como respaldo, exclusivo para clientes, SIDOM PSVA es el prestador más seguro del mercado con homologación 2019 AFIP.",
  },
  {
    title: "Track",
    description:
      "Reportes de ﻿﻿Seguimiento de estados SIM, ﻿﻿Vencimientos de destinaciones aduaneras y alertas, ﻿﻿Seguimiento de importaciones y exportaciones temporales, Impuestos pagados en línea.",
  },
  {
    title: "PSM",
    description:
      "Confección de operaciones con un PreDespacho predictivo bajo la modalidad OneWindow, mayor agilidad y seguridad, con verificaciones a medida que se ingresa la información.",
  },
  {
    title: "MiSIM",
    description:
      "Único RPA creado para la automatización y eficientización del proceso de declaración aduanera, permite oficializar desde cualquier dispositivo conectado a Internet.",
  },
  {
    title: "Info",
    description:
      "Tipos de cambio e históricos actualizados online; ﻿﻿Entrada de buques a todas las terminales ; ﻿﻿Estados de pasos fronterizos; ﻿﻿Incoterms; ﻿﻿Tipos de contenedores y sus medidas.",
  },
  {
    title: "Drive",
    description: "Almacenamiento de documentación en la nube.",
  },
  {
    title: "MOA",
    description:
      "Consulta en línea del estado de reintegros de exportación, canales, cumplidos, liberación a plaza con interfaz MOA y ARCA.",
  },
  {
    title: "COD",
    description:
      "Presentación masiva de Certificados de Origen Digitales mediante, importación de xml,  obteniendo los acuses de recibo por parte de ARCA.",
  },
];
export default function Misim() {
  const {
    misimHeroes,
    getMisimHeroes,
    misimTestimonios,
    fetchMisimTestimonios,
  } = useStore();
  const urlApi = "https://api.institucional.global.sidom.io";

  useEffect(() => {
    getMisimHeroes();
    fetchMisimTestimonios();
  }, [getMisimHeroes, fetchMisimTestimonios]);

  return (
    <>
      <header>
        <Navbar />
      </header>
      <main className="bg-sidom-light dark:bg-sidom-blue">
        <section>
          {misimHeroes?.length === 0 || !misimHeroes ? (
            <VideoBackground
              video="/placeholder.mp4"
              titulo1="Cargando..."
              titulo2="Espere un momento"
              textbutton="SOLICITAR DEMO"
              logo="/placeholder-logo.png"
            />
          ) : (
            misimHeroes.map((item, index) => (
              <VideoBackground
                key={index}
                video={`${urlApi}${item.video[0]?.url}`}
                titulo1={item.titulo}
                titulo2={item.text}
                textbutton="¡Quiero probar MiSIM!"
                link={"/misim-form"}
                logo={`${urlApi}${
                  item.img[0]?.formats?.thumbnail?.url ||
                  item.img?.url ||
                  "/placeholder-logo.png"
                }`}
                cartel={
                  <div className="flex flex-row justify-start items-center text-base font-bold text-sidom-light mb-4">
                    <p>Solo disponible en Argentina</p>
                    <div className="rounded-full ">
                      <img
                        src={ba}
                        alt="Bandera de Argentina"
                        className="ml-2 rounded-full w-9 h-9 object-cover border "
                      />
                    </div>
                  </div>
                }
              />
            ))
          )}
        </section>
        <section>
          <div className="w-full aspect-video max-h-[900px] ">
            <video
              controls
              autoPlay
              muted
              loop
              className="w-full h-full object-cover aspect-video shadow-md"
            >
              <source
                src="https://api.institucional.global.sidom.io/uploads/misim_web2_774c05790c.mp4"
                type="video/webm"
              />
            </video>
          </div>
          <div className="container mt-[60px]  mb-[100px]">
            <h2 className="text-sidom-orange text-4xl md:text-5xl font-extrabold text-left mb-[60px]">
              La solución más elegida en el mercado para la gestión de Estudios
              Aduaneros
            </h2>
            <p className="text-xl">
              Resolvé las principales dificultades operativas a partir de la
              aplicación de tecnología IA y RPA. Toda la gestión se realiza en
              remoto desde cualquier lugar del país, sin necesidad de disponer
              de terminales físicas exclusivas para Malvina.
            </p>
          </div>
        </section>
        <section className=" ">
          <BeneficiosDegradeBox />
        </section>
        <section>
          <BarrerasTecnologicas />
        </section>

        <section className="container  mb-[100px]">
          <div className="flex flex-col h-full">
            <h2 className="text-sidom-orange mt-[100px]  mb-[60px] text-4xl md:text-5xl font-extrabold text-left ">
              Beneficios
            </h2>
            {productos.map((producto, index) => (
              <CardBeneficios
                key={index}
                titulo={producto.title}
                descripcion={producto.description}
              />
            ))}
          </div>
        </section>
        <section className="bg-sidom-blue ">
          <div className="container bg-sidom-blue  flex flex-col justify-start">
            <h5 className="text-2xl md:text-3xl text-left  mt-[100px] lg:text-4xl p-1 md:p-1 lg:p-0 font-bold text-sidom-orange  dark:text-sidom-light mb-8">
              Soluciones integradas 4.0
            </h5>
          </div>
        </section>

        <section className=" bg-sidom-blue   ">
          <div className="container  bg-sidom-blue relative">
            <div className="tiny-one-item bg-sidom-blue  ">
              <TinySlider settings={settings}>
                {features.map((feature, index) => (
                  <div className="mb-[100px]" key={index}>
                    <FeatureCard
                      title={feature.title}
                      description={feature.description}
                    />
                  </div>
                ))}
              </TinySlider>
            </div>
          </div>
        </section>

        <section className=" mb-[80px]">
          <TestimoniosComex
            testimonios={misimTestimonios}
            color={"bg-sidom-light dark:bg-sidom-blue"}
          />
        </section>
        <section className="">
          <MisimClientes />
        </section>
      </main>
      <section>
        <MisimDemoForm />
      </section>
      <Switcher />
      <footer>
        <Footer />
      </footer>
    </>
  );
}
